// "Keyboard shortcuts" — GENERATED from the shared shortcut inventory
// (common/shortcutsData.ts), the same array the in-app "?" dialog renders.
// Never retype a binding here: add it to SHORTCUTS (and implement it in
// useKeyboardShortcuts.ts) and this article picks it up.
import { SHORTCUTS } from "../../../common/shortcutsData";
import type { HelpArticle, HelpBlock } from "../../types";

const GROUP_NOTES: Record<string, string> = {
  Navigation: "Press `g`, release, then the second key within about a second.",
};

const blocks: HelpBlock[] = [
  {
    kind: "lead",
    text: "Every shortcut the portal binds today, generated from the same inventory the in-app reference dialog reads. Press ? on any page to see this list without leaving your work.",
  },
  ...SHORTCUTS.flatMap((group): HelpBlock[] => [
    { kind: "heading", level: 2, text: group.group },
    ...(GROUP_NOTES[group.group]
      ? [{ kind: "paragraph", text: GROUP_NOTES[group.group] } as HelpBlock]
      : []),
    {
      kind: "shortcut-table",
      rows: group.items.map((item) => ({ keys: item.keys, action: item.desc })),
    },
  ]),
  {
    kind: "callout",
    variant: "note",
    title: "While you type",
    body: "Single-key shortcuts (`/`, `?`, and the `g` sequences) are ignored whenever an input, select, or text area has focus. `Ctrl`+`K` and `Esc` work everywhere.",
  },
  { kind: "related", topics: ["navigating-firmark"] },
];

export const keyboardShortcutsArticle: HelpArticle = {
  id: "keyboard-shortcuts",
  title: "Keyboard shortcuts",
  description: "Every binding, grouped by area. Generated from the live shortcut inventory.",
  tags: ["reference", "keyboard"],
  lastUpdated: "July 19, 2026",
  published: true,
  blocks,
};
